import { IListUser } from 'src/redux/slices/users';

import { FactoringStatus, IChequeListItem } from './cheque';

export enum FactoringBatchStatus {
  SUBMITTED = 'Submitted',
  ADVANCE_RECEIVED = 'Advance Received',
}

// Derived by the server, never stored: an advance-received batch whose
// cheques are all Cleared or settled with LOLC.
export const FACTORING_BATCH_COMPLETED = 'Completed';

export const getBatchStatusColor = (displayStatus?: string) => {
  if (displayStatus === FACTORING_BATCH_COMPLETED) return 'success';
  if (displayStatus === FactoringBatchStatus.ADVANCE_RECEIVED) return 'warning';
  return 'info';
};

export interface IDebtor {
  _id: string;
  bank: string;
  payerAccountNumber: string;
  name: string;
  returnCount: number;
  lastReturnDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IFactoringBatch {
  _id: string;
  batchDate: string;
  cheques: IChequeListItem[];
  totalAmountInCents: number;
  advanceAmountInCents: number;
  advanceReceivedDate: string | null;
  status: FactoringBatchStatus;
  displayStatus: string;
  createdBy: IListUser;
  updatedBy: IListUser;
  createdAt: string;
  updatedAt: string;
}

export interface IFactoringDebtorWarning {
  returnCount: number;
  lastReturnDate: string | null;
}

export interface IFactoringCandidate extends IChequeListItem {
  companyHeadroomInCents: number;
  debtorHeadroomInCents: number;
  debtorReturnWarning: IFactoringDebtorWarning | null;
  // True when the cheque date is outside the candidate window — only ever
  // listed for admins using "Show all cheques".
  outsideCandidateWindow: boolean;
}

export interface IFactorableSummary {
  factorableMinInCents: number;
  factorableMaxInCents: number;
  debtorsWithChoice: number;
  candidateCount: number;
  companyHeadroomInCents: number;
}

export type IFactoringBatchTableFilters = {
  status: FactoringBatchStatus | null;
  startDate: Date | null;
  endDate: Date | null;
};

export type IFactoringTableSort = {
  sortBy: string;
  order: 'asc' | 'desc';
};

export { FactoringStatus };
